<template>
  <div>
    <v-card
      hover
      :ripple="false"
      @click="isExpanded = !isExpanded"
    >
      <v-container fluid class="pb-0">
        <div v-if="false" class="mb-4">
          <v-stepper
            :value="currentStepNumber"
            class="elevation-0"
            style="max-height: 36px; white-space: nowrap; background-color: #00000000;"
          >
            <v-stepper-header style="max-height: 36px;">
              <v-stepper-step
                :complete="isStepUploadComplete"
                step="1"
                style="height: 36px;"
                class="py-0 pl-0"
              >
                <div style="display: flex;" class="body-2">
                  {{ stepUploadStatusMessage }}
                  <div
                    v-if="isStepUploadInProgress"
                    class="loading"
                    style="width: 16px;"
                  />
                </div>
              </v-stepper-step>

              <v-divider />

              <!-- TODO put back in stepper vvv -->
              <v-stepper-step
                style="height: 36px;"
                class="py-0"
                :complete="isStepCheckManufacturabilityComplete"
                :rules="[
                  () => !(!part.EstimateLineStatus.isManufacturable && !!part.EstimateLineStatus.isManufacturableMsg)
                ]"
                step="2"
              >
                <div style="display: flex;" class="body-2">
                  {{ stepCheckManufacturabilityStatusMessage }}
                  <div
                    v-if="isStepCheckManufacturabilityInProgress"
                    class="loading"
                    style="width: 16px;"
                  />
                </div>
                <small v-if="!!part.EstimateLineStatus.isManufacturableMsg">
                  {{ part.EstimateLineStatus.isManufacturableMsg }}
                </small>
              </v-stepper-step>

              <v-divider />

              <v-stepper-step
                :complete="isStepAnalysisComplete"
                step="3"
                style="height: 36px;"
                class="py-0 pr-0"
              >
                <div style="display: flex;" class="body-2">
                  {{ stepAnalysisStatusMessage }}
                  <div
                    v-if="isStepAnalysisInProgress"
                    class="loading"
                    style="width: 16px;"
                  />
                </div>
              </v-stepper-step>
            </v-stepper-header>
          </v-stepper>
        </div>

        <div style="display: grid; grid-template-columns: max-content 1fr;">
          <!--        <div style="display: flex;">-->
          <div style="display: flex; align-items: start;">
            <div v-if="!part.EstimateLineStatus.isThumbnailUploaded">
              <v-skeleton-loader type="avatar" />
            </div>

            <div v-else>
              <v-img
                :src="thumbnailSrc"
                width="112px"
                height="112px"
                alt="thumbnail"
                :class="{
                  'blip': isStepCheckManufacturabilityComplete,
                  'part-thumbnail': isStepCheckManufacturabilityComplete
                }"
                contain
                @click.stop="() => {
                  if (isStepCheckManufacturabilityComplete) {
                    $emit('thumbnail:clicked', part);
                  }
                }"
              />
            </div>
          </div>

          <div style="display: grid; grid-template-rows: max-content 1fr">
            <!--          <div style="display: flex; align-items: center;">-->
            <div>
              <v-stepper
                :value="currentStepNumber"
                class="elevation-0"
                style="max-height: 36px; white-space: nowrap; background-color: #00000000;"
              >
                <v-stepper-header style="max-height: 36px;">
                  <v-stepper-step
                    :complete="isStepUploadComplete"
                    step="1"
                    style="height: 36px;"
                    class="py-0 pl-3"
                  >
                    <div style="display: flex;" class="body-2">
                      {{ stepUploadStatusMessage }}
                      <div
                        v-if="isStepUploadInProgress"
                        class="loading"
                        style="width: 16px;"
                      />
                    </div>
                  </v-stepper-step>

                  <v-divider />

                  <!-- TODO put back in stepper vvv -->
                  <v-stepper-step
                    style="height: 36px;"
                    class="py-0"
                    :complete="isStepCheckManufacturabilityComplete"
                    :rules="[
                      () => !(!part.EstimateLineStatus.isManufacturable && !!part.EstimateLineStatus.isManufacturableMsg)
                    ]"
                    step="2"
                  >
                    <div style="display: flex;" class="body-2">
                      {{ stepCheckManufacturabilityStatusMessage }}
                      <div
                        v-if="isStepCheckManufacturabilityInProgress"
                        class="loading"
                        style="width: 16px;"
                      />
                    </div>
                    <small v-if="!!part.EstimateLineStatus.isManufacturableMsg">
                      {{ part.EstimateLineStatus.isManufacturableMsg }}
                    </small>
                  </v-stepper-step>

                  <v-divider />

                  <v-stepper-step
                    :complete="isStepAnalysisComplete"
                    step="3"
                    style="height: 36px;"
                    class="py-0 pr-0"
                  >
                    <div style="display: flex;" class="body-2">
                      {{ stepAnalysisStatusMessage }}
                      <div
                        v-if="isStepAnalysisInProgress"
                        class="loading"
                        style="width: 16px;"
                      />
                    </div>
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </div>

            <div
              style="display: grid;
                  grid-template-columns: 4fr 2fr 8fr 3fr 8fr;
                  grid-column-gap: 10px;"
            >
              <!-- TODO: Stretched out look??? Compare -->
              <!-- <div class="ml-2" style="display: flex; flex-direction: column; justify-content: space-around; height: 100%;"> -->
              <div class="mx-4">
                <div class="h6 pt-0">
                  {{ part.CustItemName }}
                </div>
                <div class="caption">
                  {{ part.CustItemDesc || 'Some Description' }}
                </div>
              </div>

              <v-text-field
                :value="parseInt(part.ReqQty)"
                :rules="[v => v > 0]"
                :disabled="isCalculatingCost"
                label="Quantity"
                type="number"
                hide-details
                dense
                outlined
                @input="part.ReqQty = parseInt($event);
                        part.EstimateLineStatus.isNestingCalculated = false;
                        part.EstimateLineStatus.isCuttingCalculated = false;"
                @click.stop
              />

              <div style="height: max-content;" @click.stop>
                <v-select
                  v-if="!isExpanded"
                  :value="materialSeries.find(m =>
                    m.ParentRowPointer === part.Material
                    && m.RowPointer === part.MaterialSeries)"
                  :items="materialSeries"
                  :disabled="isCalculatingCost"
                  label="Material"
                  item-text="Description"
                  persistent-hint
                  return-object
                  dense
                  hide-details
                  single-line
                  outlined
                  flat
                  @input="part.Material = $event.ParentRowPointer;
                          part.MaterialSeries = $event.RowPointer;"
                  @change="part.MaterialThickness = '';
                           part.MaterialFinish = '';
                           part.MaterialFinishOption = '';
                           part.EstimateLineStatus.isNestingCalculated = false;
                           part.EstimateLineStatus.isCuttingCalculated = false;"
                />

                <v-card
                  v-else
                  flat
                  style="background-color:#00000000; border: solid 1px rgba(0,0,0,.42);"
                  @click.stop
                >
                  <v-list :disabled="isCalculatingCost">
                    <v-list-item-group
                      :value="materialSeries.findIndex(m =>
                        m.ParentRowPointer === part.Material
                        && m.RowPointer === part.MaterialSeries)"
                      color="primary"
                      @change="part.MaterialThickness = '';
                               part.MaterialFinish = '';
                               part.MaterialFinishOption = '';
                               part.EstimateLineStatus.isNestingCalculated = false;
                               part.EstimateLineStatus.isCuttingCalculated = false;"
                    >
                      <v-list-item
                        v-for="(item, index) in materialSeries"
                        :key="index"
                        style="height: 20px; !important;"
                        @click.stop="part.Material = item.ParentRowPointer;
                                     part.MaterialSeries = item.RowPointer;"
                      >
                        <v-list-item-title>{{ item.Description }}</v-list-item-title>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </div>

              <div style="height: max-content; width: 100%;" @click.stop>
                <v-select
                  v-if="!isExpanded"
                  :value="part.MaterialThickness"
                  :items="part.MaterialSeries ? thicknesses : [{ Description: detectedThickness }]"
                  :disabled="isCalculatingCost || !part.MaterialSeries"
                  label="Thicknesses"
                  item-text="Description"
                  item-value="_id"
                  dense
                  return-object
                  hide-details
                  single-line
                  outlined
                  @input="part.MaterialThickness = $event._id"
                  @change="fetchFinishes({
                             query: {
                               Item: $event.Item,
                             }
                           });
                           part.MaterialFinish = '';
                           part.MaterialFinishOption = '';
                           part.EstimateLineStatus.isNestingCalculated = false;
                           part.EstimateLineStatus.isCuttingCalculated = false;"
                />

                <v-card
                  v-else
                  flat
                  style="background-color:#00000000; border: solid 1px rgba(0,0,0,.42); width: 100%;"
                  @click.stop
                >
                  <v-list :disabled="isCalculatingCost || !part.MaterialSeries">
                    <v-list-item-group
                      :value="thicknesses.findIndex(t => part.MaterialThickness === t._id)"
                      color="primary"
                      @change="$event && fetchFinishes({
                                 query: {
                                   Item: thicknesses[$event].Item,
                                 }
                               });
                               part.MaterialFinish = '';
                               part.MaterialFinishOption = '';
                               part.EstimateLineStatus.isNestingCalculated = false;
                               part.EstimateLineStatus.isCuttingCalculated = false;"
                    >
                      <v-list-item
                        v-for="(item, index) in part.MaterialSeries
                          ? thicknesses
                          : [{ Description: detectedThickness
                            ? `${detectedThickness}mm`
                            : 'Detecting...' }]"
                        :key="index"
                        :disabled="isCalculatingCost || !part.MaterialSeries"
                        style="height: 20px; !important;"
                        @click.stop="part.MaterialThickness = item._id"
                      >
                        <v-list-item-title>{{ item.Description }}</v-list-item-title>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </div>

              <div style="height: max-content;" @click.stop>
                <v-select
                  v-if="!isExpanded"
                  :value="surfaceFinishes.find(f => part.MaterialFinishOption
                    ? part.MaterialFinish === f.ParentRowPointer && part.MaterialFinishOption === f.RowPointer
                    : part.MaterialFinish === f.RowPointer && part.MaterialFinishOption === '')"
                  :items="surfaceFinishes"
                  :disabled="isCalculatingCost || !part.MaterialThickness"
                  :loading="isFinishesFindPending"
                  :item-disabled="finish => finish.IsHidden"
                  label="Finishes"
                  item-text="Description"
                  dense
                  return-object
                  hide-details
                  single-line
                  outlined
                  @input="($event) => {
                    if ($event.ParentRowPointer) {
                      part.MaterialFinish = $event.ParentRowPointer;
                      part.MaterialFinishOption = $event.RowPointer;
                    } else {
                      part.MaterialFinish = $event.RowPointer;
                      part.MaterialFinishOption = '';
                    }
                  }"
                  @change="part.EstimateLineStatus.isNestingCalculated = false;
                           part.EstimateLineStatus.isCuttingCalculated = false;"
                />

                <v-card
                  v-else
                  flat
                  style="background-color:#00000000; border: solid 1px rgba(0,0,0,.42);"
                  @click.stop
                >
                  <v-list :disabled="isCalculatingCost || !part.MaterialThickness">
                    <v-list-item-group
                      :value="surfaceFinishes.filter(f => !f.header).findIndex(f => part.MaterialFinishOption
                        ? part.MaterialFinish === f.ParentRowPointer && part.MaterialFinishOption === f.RowPointer
                        : part.MaterialFinish === f.RowPointer && part.MaterialFinishOption === '')"
                      color="primary"
                      @change="part.EstimateLineStatus.isNestingCalculated = false;
                               part.EstimateLineStatus.isCuttingCalculated = false;"
                    >
                      <template v-for="(item, index) in surfaceFinishes">
                        <v-list-item
                          v-if="item.Description"
                          :key="index"
                          :disabled="!part.MaterialThickness || item.IsHidden"
                          style="height: 20px; !important;"
                          @click.stop="() => {
                            if (item.ParentRowPointer) {
                              part.MaterialFinish = item.ParentRowPointer;
                              part.MaterialFinishOption = item.RowPointer;
                            } else {
                              part.MaterialFinish = item.RowPointer;
                              part.MaterialFinishOption = '';
                            }
                          }"
                        >
                          <v-list-item-title>{{ item.Description }}</v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </div>
            </div>
          </div>
        </div>
      </v-container>

      <v-card-actions class="pt-0">
        <div style="display: flex; position:relative; width: 100%">
          <v-btn
            :disabled="!isStepCheckManufacturabilityComplete"
            text
            @click.stop="$emit('thumbnail:clicked', part);"
          >
            Analysis
          </v-btn>
          <v-btn
            text
            :disabled="!canCalculateCost"
            :loading="isCalculatingCost"
            @click.stop="$emit('calculatecost', part)"
          >
            {{ part.isCsi ? 'Recalculate Cost' : 'Calculate Cost' }}
          </v-btn>

          <v-icon style="position: absolute; left: 0; right: 0; margin: 0 auto; bottom: -12px;">
            {{ `mdi-chevron-${isExpanded ? 'up' : 'down'}` }}
          </v-icon>

          <v-spacer />

          <v-btn
            icon
            color="error"
            @click.stop="part.remove()"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { models } from 'feathers-vuex';

const { Material, Finish } = models.api;

export default {
  name: 'UploadPartCard',

  props: {
    part: Object,
    materials: Array,
  },

  data() {
    return {
      isExpanded: false,
    };
  },

  computed: {
    ...mapGetters('materials', {
      findMaterials: 'find',
      getMaterials: 'get',
    }),

    ...mapState('temp-rfqs', {
      isPatchTempRfqsPending: 'isPatchPending',
      isCreateTempRfqsPending: 'isCreatePending',
    }),

    ...mapState('temp-parts', {
      isPatchTempPartsPending: 'isPatchPending',
      isCreateTempPartsPending: 'isCreatePending',
    }),

    ...mapGetters('finishes', { findFinishes: 'find' }),
    ...mapState('finishes', { isFinishesFindPending: 'isFindPending' }),
    ...mapGetters('parts', { getPart: 'get' }),
    ...mapGetters('thumbnails', { getThumbnail: 'get' }),

    thumbnailSrc() {
      const host = process.env.VUE_APP_API_URL || 'http://localhost:3031/';
      return `${host}uploads/${this.part.DrawingRowPointer}-folded.png`;
    },

    detectedThickness() {
      if (!this.part.EstimateLineStatus.isManufacturable) {
        return 0;
      }
      const manufacturability = JSON.parse(this.part.AnalysisResult.manufacturability);
      return manufacturability.CADMAN.PARTTYPELIST.PARTSHEETMETALTYPE.Thickness;
    },

    closestAvailableThicknessToDetected() {
      if (_.isEmpty(this.thicknesses)) {
        return 0;
      }
      return 0;
    },

    canCalculateCost() {
      if (_.isEmpty(this.options) && !this.part.MaterialFinish) {
        return false;
      }
      if (!_.isEmpty(this.options) && !this.part.MaterialFinishOption) {
        return false;
      }
      return !this.isCalculatingCost
        && this.part.EstimateLineStatus.isManufacturable
        && (!this.part.EstimateLineStatus.isNestingCalculated || !this.part.EstimateLineStatus.isCuttingCalculated);
    },

    isCalculatingCost() {
      return this.part.EstimateLineStatus.isCalculatingCutting
        || this.part.EstimateLineStatus.isCalculatingNesting;
    },

    selectedThickness() {
      return this.thicknesses.find((t) => t._id === this.part.MaterialThickness);
    },

    status() {
      return this.part.EstimateLineStatus;
    },

    currentStepNumber() {
      let stepNo = 1;
      if (this.isStepUploadComplete) { stepNo++; }
      if (this.isStepCheckManufacturabilityComplete) { stepNo++; }

      return stepNo;
    },

    isStepPartCreationComplete() {
      return !_.get(this, 'part.__isTemp', false);
    },

    isStepPartCreationInProgress() {
      return /* this.isStepUploadComplete &&  */!this.isStepPartCreationComplete;
    },

    stepPartCreationStatusMessage() {
      return this.isStepPartCreationComplete
        ? 'Part Created'
        : 'Creating Part';
    },

    isStepUploadComplete() {
      return this.isStepPartCreationComplete && this.part.EstimateLineStatus.isDrawingUploaded;
    },

    isStepUploadInProgress() {
      return this.isStepPartCreationComplete
        && !this.part.EstimateLineStatus.isDrawingUploaded
        && !this.part.EstimateLineStatus.isDrawingUploadedMsg;
      // return !this.isStepUploadComplete;
    },

    stepUploadStatusMessage() {
      if (!this.isStepPartCreationComplete) {
        return 'Upload Drawing';
      }
      if (this.isStepUploadInProgress) {
        return 'Uploading Drawing';
      }
      return 'Drawing Uploaded';
    },

    isStepCheckManufacturabilityComplete() {
      return this.part.EstimateLineStatus.isManufacturable;
    },

    isStepCheckManufacturabilityInProgress() {
      return this.isStepUploadComplete
        && !this.part.EstimateLineStatus.isManufacturable
        && !this.part.EstimateLineStatus.isManufacturableMsg;
    },

    stepCheckManufacturabilityStatusMessage() {
      if (this.isStepCheckManufacturabilityComplete) {
        return 'Drawing Validated';
      }
      if (this.isStepCheckManufacturabilityInProgress) {
        return 'Validating Drawing';
      }
      if (!this.part.EstimateLineStatus.isManufacturableMsg) {
        return 'Validate Drawing';
      }
      return 'Drawing Invalid';
    },

    isStepAnalysisComplete() {
      return this.part.EstimateLineStatus.isCuttingCalculated
        && this.part.EstimateLineStatus.isNestingCalculated;
    },

    isStepAnalysisInProgress() {
      return this.part.EstimateLineStatus.isCalculatingNesting
        || this.part.EstimateLineStatus.isCalculatingCutting;
    },

    stepAnalysisStatusMessage() {
      if (this.isStepAnalysisComplete) {
        return 'Drawing Analyzed';
      }
      if (this.isStepAnalysisInProgress) {
        return 'Analyzing Drawing';
      }
      /* TODO error? */
      return 'Analyze Drawing';
    },

    uploadProgress() {
      return _.get(this.part, 'uploadProgress', 100);
    },

    materialSeries() {
      const materials = Material.findInStore({
        query: {
          ParentRowPointer: null,
          IsHidden: false,
        },
      }).data;

      const series = Material.findInStore({
        query: {
          ParentRowPointer: { $in: materials.map((m) => m.RowPointer) },
          IsHidden: false,
          $sort: { Rank: 1 },
        },
      }).data;

      return series;
    },

    thicknesses() {
      return this.part.MaterialSeries ? this.findMaterials({
        query: {
          ParentRowPointer: this.part.MaterialSeries,
          IsHidden: false,
          $sort: { Rank: 1 },
        },
      }).data : [];
    },

    surfaceFinishes() {
      const finishes = Finish.findInStore({
        query: {
          $sort: { Rank: 1 },
        },
      }).data;

      const availableFinishes = finishes.filter((finish) => finish.ParentRowPointer
          || !finishes.find((f) => f.ParentRowPointer === finish.RowPointer));

      const applicableFinishes = [];
      const nonApplicableFinishes = [];

      availableFinishes.forEach((f) => (f.IsHidden
        ? nonApplicableFinishes.push(f)
        : applicableFinishes.push(f)));

      return [
        { header: 'Applicable' },
        ...applicableFinishes,
        { header: 'Not Applicable' },
        ...nonApplicableFinishes,
      ];
    },
  },

  watch: {
    canCalculateCost(val, oldVal) {
      /* TODO Log to see if we can always emit,
      * or only when goes from false to true */
      // this.$emit('change:canCalculateCost', val);
      this.part.EstimateLineStatus.canCalculateCost = val;
    },

    selectedThickness(thickness) {
      this.part.RawMaterial = thickness ? thickness.Item : '';
    },
  },

  methods: {
    ...mapActions('parts', { updatePart: 'update' }),
    ...mapActions('finishes', { fetchFinishes: 'find' }),

    selectClosestAvailableThickness() {
      if (this.detectedThickness === 0 || _.isEmpty(this.thicknesses)) {
        return;
      }

      const closestToDetected = this.thicknesses
        .map((t) => {
          /* T=2.25mm becomes 2.25, all thicknesses are formatted this way */
          const thickness = parseFloat(t.Description.slice(2, -2));
          const difference = Math.abs(thickness - this.detectedThickness);

          return { id: t._id, difference };
        })
        .sort((t1, t2) => t1.difference - t2.difference);

      this.part.MaterialThickness = _.get(closestToDetected, '0.id', '');
    },

    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
    },

    getMaterialDescription(materialID) {
      const mat = this.getMaterials(materialID);
      return mat ? mat.Description : '';
    },

    isFinishAvailable(finishID) {
      return this.selectedThickness && this.findFinishes({
        query: {
          IsHidden: false,
          ParentRowPointer: null,
          Item: this.selectedThickness.Item,
          _id: finishID,
        },
      }).data.length > 0;
    },
  },
};
</script>

<style scoped>
>>> .v-list-item {
  min-height: 30px;
}

.hidden {
  visibility: hidden;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.loading:after {
  overflow: hidden;
  display: inline-block;
  vertical-align: bottom;
  -webkit-animation: ellipsis steps(4,end) 900ms infinite;
  animation: ellipsis steps(4,end) 900ms infinite;
  content: "\2026"; /* ascii code for the ellipsis character */
  width: 0px;
}

.part-thumbnail:hover {
  cursor: pointer;
}

@keyframes ellipsis {
  to {
    width: 1.25em;
  }
}

@-webkit-keyframes ellipsis {
  to {
    width: 1.25em;
  }
}

>>> .v-skeleton-loader__avatar {
  width: 112px !important;
  height: 112px !important;
}

>>> .v-input--radio-group__input {
  display: flex;
  justify-content: center;
}

.blip {
  /* background: black; */
  border-radius: 50%;
  /* box-shadow: 0 0 0 0 rgba(0, 0, 0, 1); */
  box-shadow: 0 0 0 0 rgba(51, 217, 178, 1);

  /* margin: 10px; */
  height: 20px;
  width: 20px;
  transform: scale(1);
  animation: pulse-green 2s infinite;
}

@keyframes pulse-green {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(51, 217, 178, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(51, 217, 178, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(51, 217, 178, 0);
  }
}
</style>
